export default __webpack_public_path__ + "static/double-marker-line-d9f2e87646afbff17c48a390bd0a0cf0.svg";